export default {
    CalendarPublishingCreateNewPermission: {
        datapoint: {
            name: 'CALENDARPUBLISHING_CREATENEWPERMISSION',
            customData: (permissionLevel: string): any => ({
                permissionLevel: permissionLevel,
            }),
        },
    },
    CalendarPublishingUnpublish: {
        datapoint: {
            name: 'CALENDARPUBLISHING_UNPUBLISH',
        },
    },
    CalendarPublishingResetLinks: {
        datapoint: {
            name: 'CALENDARPUBLISHING_RESETLINKS',
        },
    },
};
